// extracted by mini-css-extract-plugin
export default {"utilityWrapper":"UtilityIcon_utilityWrapper__+81Qw","utilityIcon":"UtilityIcon_utilityIcon__DrYhN"};